console.log('[Variant Fix] Script loaded');

document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('form.shopify-product-form');
  if (!form) return;

  const optionInputs = form.querySelectorAll('input[name^="option-"]');
  const variantSelect = form.querySelector('select[name="id"]');
  const variantsEl = document.querySelector('[type="application/json"][data-product-json]');

  if (!variantsEl) return;

  const productData = JSON.parse(variantsEl.textContent);
  const variants = productData.variants;

  function updateVariantFromOptions() {
    const selectedOptions = [];
    optionInputs.forEach((input) => {
      if (input.checked) {
        const index = parseInt(input.name.split('-')[1]);
        selectedOptions[index] = input.value;
      }
    });

    const matchingVariant = variants.find(v =>
      v.options.every((opt, idx) => opt === selectedOptions[idx])
    );

    if (matchingVariant) {
      variantSelect.value = matchingVariant.id;
      variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  optionInputs.forEach((input) => {
    input.addEventListener('change', updateVariantFromOptions);
  });
});
